import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Bar by Category panel art: five categories ranked down the card, each a label
 * pill and a horizontal bar running along a faint track. Lengths and alpha both
 * fall away from the leader at the top.
 */

/** [row top y, bar width, bar alpha] */
const ROWS: [number, number, number][] = [
  [16, 104, 0.7],
  [30, 86, 0.6],
  [44, 68, 0.5],
  [58, 48, 0.4],
  [72, 30, 0.32],
]

export function BarCategoryArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      {ROWS.map(([y, width, alpha]) => (
        <g key={y}>
          <rect x={12} y={y} width={26} height={10} rx={3} fill="hsl(var(--foreground) / 0.22)" />
          <rect x={42} y={y} width={104} height={10} rx={3} fill="hsl(var(--foreground) / 0.08)" />
          <rect
            x={42}
            y={y}
            width={width}
            height={10}
            rx={3}
            fill={`hsl(var(--primary) / ${alpha})`}
          />
        </g>
      ))}
    </svg>
  )
}
